<template>
  <div class="new-detail-breadcrumb">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-if="$store.state.locale!=='uk'" @click.native="handleClick('/courses/list')">
        <nuxt-link :to="categoryPath" v-if="$store.state.locale!=='us'">
          {{ categoryName }}
        </nuxt-link>
        <nuxt-link to="" v-else>
          {{ categoryName }}
        </nuxt-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <nuxt-link v-if="secondCategoryPath" :to="secondCategoryPath">
          {{ secondCategoryName }}
        </nuxt-link>
        <template v-else>
          {{ secondCategoryName }}
        </template>
      </el-breadcrumb-item>
      <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>
<script>
export default {
  props: {
    categoryName: {
      type: String,
      default: '',
    },
    categoryPath: {
      type: String,
      default: '',
    },
    secondCategoryName: {
      type: String,
      default: '',
    },
    secondCategoryPath: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleClick(path) {
      if(this.$store.state.locale !== 'us'){
        this.$router.push(path);
      }
    }
  },
}
</script>
<style lang="scss">
.new-detail-breadcrumb {
  .el-breadcrumb__inner {
    a {
      font-weight: 500;
      font-size: 14px;
      color: #606266;
    }
  }

  .el-breadcrumb__inner:hover {
    a {
      color: var(--txt-color-link);
    }
  }
}

</style>
